import React from "react";
import Select from "react-select";
import "./custom-multiselect.scss";

const CustomMultiSelect = ({
                               options,
                               placeholder,
                               onChange,
                               defaultValue = [],
                           }) => {
    return (
        <div className="custom-multiselect">
            <Select
                options={options}
                placeholder={placeholder}
                isMulti
                closeMenuOnSelect={false}
                defaultValue={defaultValue}
                onChange={(vals) => {
                    const arr = vals ? vals.map(v => v.value) : [];
                    onChange(arr);
                }}
            />
        </div>
    );
};

export default CustomMultiSelect;
